<template>
<div>

    <!-- page header -->
    <page-heading show="true" pageTitle="HEADER_REMINDER"></page-heading>


    <div class="columns">

        <div class="col-main">

            <template v-if="reminder=='products'">

                <span class="select is-medium">
                    <select v-model="email.recipients">
                        <option :value="null">{{ $t('REMINDER-SELECT_BOX-CHOOSE_MANUFACTURER') }}</option>
                        <option :value="all">{{ $t('REMINDER-SELECT_BOX-ALL_MANUFACTURERS') }}</option>
                        <option v-for="(manufacturer, index) in manufacturers" :value="manufacturer.id">{{ manufacturer.name }}</option>
                    </select>
                </span>

            </template>


            <div class="box">

                <!-- TEMPLATES -->
                <div class="control is-horizontal">
                    <div class="control-label">
                        <label-name labelKey="EMAIL-SEND_EMAIL-TEMPLATE"></label-name>
                    </div>
                    <div class="control">
                        <span class="select is-medium">
                            <select id="template" v-model="selectedTemplate" v-on:change="setTemplate()"> <!-- v-on:change="setTemplate($event) -->
                                <option :value="null">{{ $t('REMINDER-SELECT_BOX-CHOOSE_TEMPLATE') }}</option>
                                <option v-for="(template, index) in templates" :value="template">{{ template.name }}</option>
                            </select>
                        </span>
                    </div>
                </div>

                <br  />

                <!-- SUBJECT -->
                <div class="control is-horizontal">
                    <div class="control-label">
                        <label-name labelKey="EMAIL-SEND_EMAIL-SUBJECT"></label-name>
                    </div>
                    <div class="control">
                        <input type="text" id="EMAIL-SEND_EMAIL-SUBJECT" class="input is-medium" v-model="email.subject">
                    </div>
                </div>

                <!-- BODY -->
                <div class="control is-horizontal">
                    <div class="control-label">
                        <label-name labelKey="EMAIL-SEND_EMAIL-BODY"></label-name>
                    </div>
                    <div class="control">
                        <textarea type="text" id="EMAIL-SEND_EMAIL-BODY" class="textarea is-medium isLarge" v-model="email.body"></textarea>
                    </div>
                </div>

                <!-- SIGNATUR -->
                <div class="control is-horizontal">
                    <div class="control-label">
                        <label-name labelKey="EMAIL-SEND_EMAIL-SIGNATURE"></label-name>
                    </div>
                    <div class="control">
                        <textarea type="text" id="EMAIL-SEND_EMAIL-SIGNATURE" class="textarea is-medium" v-model="email.signature"></textarea>
                    </div>
                </div>

                <br />

                <!-- TEST EMAIL -->
                <div class="control is-horizontal">
                    <div class="control-label">

                        <label-name labelKey="EMAIL-SEND_EMAIL-TEST_EMAIL">
                            <tooltip slot="icon" content="Geben Sie hier eine Test Email Adresse ein">
                                <span class="icon is-small"><i class="fa fa-question-circle-o"></i></span>
                            </tooltip>
                        </label-name>

                    </div>

                    <div class="control">
                        <input type="text" id="EMAIL-SEND_EMAIL-TEST_EMAIL" class="input is-medium" v-model="testRecipient">
                    </div>
                </div>

                <!-- KOPIE EMAIL -->
                <div class="control is-horizontal">
                    <div class="control-label">
                        <label-name labelKey="EMAIL-SEND_EMAIL-SEND_CC"></label-name>
                    </div>
                    <div class="control">
                        <input type="text" id="EMAIL-SEND_EMAIL-SEND_CC" class="input is-medium" v-model="email.cc">
                    </div>
                </div>

                <!-- NO REPLY EMAIL -->
                <div class="control is-horizontal">
                    <div class="control-label">
                        <label-name labelKey="EMAIL-SEND_EMAIL-REPLY_TO"></label-name>
                    </div>
                    <div class="control">
                        <input type="text" id="EMAIL-SEND_EMAIL-REPLY_TO" class="input is-medium" v-model="email.replyTo">
                    </div>
                </div>


                <div class="control is-horizontal">

                    <div class="control-label"></div>

                    <div class="control is-clearfix">

                        <div class="is-pulled-right">

                            <transition name="fadeLeft">
                                <button :class="isSending ? 'is-loading' : ''" class="button is-normal is-success" @click="sendEmail('test')" v-if="testRecipient!=null && testRecipient != ''">
                                    <span class="icon is-small"><i class="icon-ak-nachricht"></i></span><br />
                                    <lang labelKey="EMAIL-SEND_EMAIL-SEND_TEST_EMAIL"></lang>
                                </button>
                            </transition>

                            <transition name="fadeLeft" >
                            <button :class="isSending ? 'is-loading' : ''" class="button is-normal is-success" @click="sendEmail()" v-if="testRecipient==null || testRecipient==''">
                                <span class="icon is-small"><i class="icon-ak-nachricht"></i></span><br />
                                <lang labelKey="EMAIL-SEND_EMAIL-SEND_EMAIL"></lang>
                            </button>
                            </transition>

                        </div>

                    </div>
                </div>



            </div>


        </div>

        <div class="col-aside">


        </div>


    </div>


</div>
</template>



<script>
export default {

    props: ['recipients'],

	data() {

		return {
            reminder: null,
            manufacturers: null,
            templates: null,
            recipients: null,
            selectedTemplate: null,
            isSending: false,
            testRecipient: null,
            showTestEmailBtn: false,
            email: {
                to: 'matthias@jumptomorrow',
                subject: null,
                body: null,
                from: 'noreply@apothekenkatalog.at',
                replyTo: null,
                replyToDefault: 'noreply@apothekenkatalog.at',
                cc: null,
                bcc: null,
                signature: null
            }
        }

    },

    created() {

        this.fetchTemplates();

        if(this.$route.name == 'catalogReminder') {
            this.reminder = "catalog";

        } else if(this.$route.name == 'productsReminder') {

            this.reminder = "products";
            this.fetchDataProducts();

        }


    },


    mounted() {

    },


    computed: {


    },


    methods: {

        setTemplate() {

            // assign template
            if(this.selectedTemplate != null) {

                this.email.subject = this.selectedTemplate.subject;
                this.email.body = this.selectedTemplate.body;

            // reset fields
            } else {

                this.email.subject = "";
                this.email.body = "";

            }

        },


        fetchDataProducts() {

			var self = this;

            // manufacturers
            function getManufacturers() {
                return self.axios.get(self.$config.api + 'manufacturer?orderBy=name');
            }

            // products
            function getProducts() {
                return self.axios.get(self.$config.api + 'product?orderBy=name');
            }

            this.axios.all([getManufacturers(), getProducts()])
              .then(self.axios.spread( function(manufacturers, products) {

                  self.manufacturers = manufacturers.data.manufacturer;
                  self.products = products.data.product;

                  self.isLoading = false;


              }));


		},


        fetchTemplates() {

            this.isLoading = true;
            var self = this;

            // fetch data
            this.axios.get(this.$config.api + 'mailTemplate')
                .then(function(response) {
					self.templates = response.data.mailTemplate;
                    self.isLoading = false;
                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        },


        sendEmail(type) {

            var recipients = "";

            // test for subject
            if(this.email.subject == null || this.email.subject == '') {
                this.$notify.open({content: this.$t('MSG-ERROR-EMAIL-NO_SUBJECT_GIVEN'), type: 'warning'});
                return false;
            }

            // test for body
            if(this.email.body == null || this.email.body == '') {
                this.$notify.open({content: this.$t('MSG-ERROR-EMAIL-NO_TEXT_GIVEN'), type: 'warning'});
                return false;
            }

            // check for replyTo email address and if it is valid
            if(this.email.replyTo != null && this.email.replyTo != '') {

                if(this._validateEmail(this.email.replyTo) == false) {
                    this.$notify.open({content: this.$t('MSG-ERROR-EMAIL-REPLYTO_NOT_VALID'), type: 'warning'});
                    return false;
                }

            }

            // check cc
            if(this.email.cc != null && this.email.cc != '') {

                if(this._validateEmail(this.email.cc) == false) {
                    this.$notify.open({content: this.$t('MSG-ERROR-EMAIL-CC_NOT_VALID'), type: 'warning'});
                    return false;
                }

            }


            // if test email should be sent
            if(type == "test") {

                // and no test Email address was given ...
                if(this.testRecipient == '') {

                    this.$notify.open({content: this.$t('MSG-ERROR-EMAIL-NO_TESTEMAIL_GIVEN'), type: 'warning'});
                    return false;

                } else {

                    if(this._validateEmail(this.testRecipient) == false) {
                        this.$notify.open({content: this.$t('MSG-ERROR-USER-EMAIL_NOT_VALID'), type: 'warning'});
                        return false;
                    }

                    console.log("RECIPIENT: ", this.testRecipient);

                    recipients = this.testRecipient;

                }

            // otherwise check if recipientlist was given ...
            } else {

                // if no recipientlist was given ...
                if(this.recipients == null || this.recipients.length == 0) {
                    this.$notify.open({content: this.$t('MSG-ERROR-EMAIL-NO_RECIPIENTS_GIVEN'), type: 'warning'});
                    return false;
                }

                recipients = [this.recipients].join(';');

            }


            // email body
            var htmlBody = this.nl2br(this.email.body);
            if(this.email.signature != null && this.email.signature != '') {
                htmlBody += '<br /><br />---<br />' + this.nl2br(this.email.signature) + '<br /><br />';
            }


            // prepare our sendData object
            var sendData = {
                to: recipients,
                subject: this.email.subject,
                htmlBody: htmlBody,
                from: this.email.from,
                replyTo: this.email.replyTo != '' && this.email.replyTo != null ? this.email.replyTo : this.email.replyToDefault,
                cc: this.email.cc != '' ? this.email.cc : null,
                bcc: this.email.bcc
                // this.email.cc != null ? 'cc: this.email.cc : '',
                // bcc: 'matthias@jumptomorrow.com'
            }


            var self = this;
            this.isSending = true;

			this.axios.post(this.$config.api+'mail/sendMail', sendData)
				.then(function(response) {
					self.isSending = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-EMAIL-SUCCESSFULLY_SENT')});
				}).catch(function(error) {
					self.isSending = false;
					self.$notify.open({content: self.$t('MSG-ERROR-EMAIL-NOT_SENT') + ': ' + error.message, type: 'danger'});
					console.log(error);
				});


            /*
            Parameter:

            to (recipientEmail)
            subject
            htmlBody
            from
            replyTo
            cc (strichkomma-separierte liste von email-Adressen)
            bcc (strichkomma-separierte liste von email-Adressen)
            */

        },

        _validateEmail(email) {

            // validate the test email ...
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(!re.test(email)) {
                return false;
            }

            return true;

        },



    },


}


</script>



<style scoped>
    textarea.isLarge {
        min-height: 500px;
    }
</style>
